import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-contact-edit-replace'), el => new Bridge(el))
})
